import {observer} from "mobx-react-lite";
import React, {Fragment, useContext, useEffect, useRef} from "react";
import {Store} from "../../app/stores/store-root";
import AccountSummary from "./common/account-orders-summary";
import {AdminsOrdersList} from "./admin/pending-approvals-orders-list";
import {SendAgentOrdersList} from "./send-agent/send-agent-orders-list";
import {ReceiveAgentOrdersList} from "./receive-agent/receive-agent-orders-list";
import {
    EuiBreadcrumbs,
    EuiButton,
    EuiPageContent,
    EuiPageContentHeader,
    EuiPageContentHeaderSection,
    EuiSpacer,
    EuiTitle
} from "@elastic/eui";
import {useHistory} from "react-router-dom";
import ListSupportTickets from "../support-tickets/list/list-support-tickets";
import ListSupportTicketsForAdmin from "../support-tickets/list/list-admin-support-tickets.";
import {Ticket} from "../../app/models/Ticket";
import {CashierAgentOrdersList} from "./cashier/cashier-agent-orders-list";
import { useReactToPrint } from 'react-to-print';
import SupervisorOrderList from "./supervisior/supervisor-order-list";
import {allTransferTypes, bankOnlyTrasnferType} from "../../app/stores/store-lookups.";

const Dashboard = () => {

    const store = useContext(Store);
    const {CleanedOrders} = store.Orders.PendingApprovalOrders;
    const {MyOrders, ReadyOrders} = store.Orders;
    const history = useHistory();

    useEffect(() => {
        store.Orders.PendingApprovalOrders.loadItems();
        store.Orders.LoadReadyOrders();
        store.Lookups.setTransferTypes(allTransferTypes)
        console.log(store.Users.user)
        if (store.Users.UserName) {
            store.Orders.LoadOrderSummaryForAgent(store.Users.Sub);
            store.Orders.LoadMyOrders(store.Users.UserName);
            store.SupportTickets.LoadAllTickets();
            store.SupportTickets.LoadMyTickets(store.Users.Sub);
        }

    }, [store.Orders, store.Users.UserName, store.Users.user]);


    //Load orders data
    const breadcrumbs = [
        {
            text: 'Remittance App',
            href: '#',
            onClick: (e: any) => {
                e.preventDefault();
            },
            'data-test-subj': 'breadcrumbsAnimals',
        },
        {
            text: 'Dashboard',
        },
        /*{
            text: 'Boa constrictor',
            href: '#',
            onClick: (e:any) => {
                e.preventDefault();
            },
        },
        {
            text: 'Edit',
        },*/
    ];
    const onCloseSupportTicket = async (ticket: Ticket) => {
        await store.SupportTickets.CloseTicket(ticket)
    }

    return (
        <Fragment>
            <EuiPageContent>
                <EuiBreadcrumbs
                    breadcrumbs={breadcrumbs}
                    truncate={false}
                    aria-label="An example of EuiBreadcrumbs"
                />
                <EuiSpacer size="xs"/>
                <EuiPageContentHeader>
                    <EuiPageContentHeaderSection>
                        <EuiTitle size="l">
                            <h1>Dashboard</h1>
                        </EuiTitle>
                    </EuiPageContentHeaderSection>
                    {
                        (store.Users.isReceiveAgent || store.Users.isCashier || store.Users.isSupervisor ) ? '' : (<EuiPageContentHeaderSection>
                            <EuiButton onClick={() => history.push('/orders/create')}
                            id='create_new_order'>New Order Transfer</EuiButton>
                        </EuiPageContentHeaderSection>)
                    }

                </EuiPageContentHeader>
                {(store.Users.isAdmin || store.Users.isSendingAgent) ? ((store.Orders.Summary) ? (
                    <AccountSummary/>) : '') : ''}

            </EuiPageContent>

            <div className="mt-8 space-y-10">


                {(store.Users.isAdmin) ? <AdminsOrdersList items={CleanedOrders}/> : ''}
                {(store.Users.isSendingAgent) ? <SendAgentOrdersList items={MyOrders}/> : ''}
                {(store.Users.isReceiveAgent) ? <ReceiveAgentOrdersList items={store.Orders.SupervisorOrders}/> : ''}
                {(store.Users.isCashier) ? <CashierAgentOrdersList  items={ReadyOrders}/> : ''}
                {(store.Users.isSupervisor) ? <SupervisorOrderList/> : ''}
                {(store.Users.isAdmin) ?
                    <ListSupportTicketsForAdmin items={store.SupportTickets.AllTicketsFilteredToOutstanding}
                                                onCloseTicket={onCloseSupportTicket}/> : ''}
                {(store.Users.isSendingAgent || store.Users.isReceiveAgent) ?
                    <ListSupportTickets items={store.SupportTickets.MyTickets}/> : ''}
            </div>
        </Fragment>
    );
};


export default observer(Dashboard)

